import { SUBSCRIPTIONS } from '../../constants';

const {
  PAYMENT_STATUS: { PAID }
} = SUBSCRIPTIONS;

export const isValidSubscription = subscription => {
  const isPaid = subscription?.payment?.status === PAID;
  const now = Date.now();
  const isActive = parseInt(subscription?.endDate || now) >= now;

  return isPaid && isActive;
};

export const scrollTo = ref => {
  window.scrollTo(0, ref.current.offsetTop - 100);
};
